import CONSTANT from "../../constants/Constant";

export const initialSweetAlertState = {
    isVisible: false,
    config: {
        showConfirmBtn: true,
        showOkBtn: false,
        showCancelBtn: true,
        title: '',
        message: '',
        confirmBtnText: 'Yes',
        cancelBtnText: 'No',
        confirmBtnCssClass: '',
        cancelBtnCssClass: '',
        okLoading: false,
        noLoading: false,
        type: CONSTANT.ALERT_TYPE.INFO,
        onConfirmKey: null,
        onCancelKey: null,
        onCloseKey: null,
        closeOnClickOutside: false,
        textWhileProcessingConfirmBtn: 'Saving...',
        textWhileProcessingCancelBtn: 'Saving...',
    }
};
